import React from 'react';
import { useSelector } from 'react-redux';

// Components
import EntityNameValue from 'components/EntityNameValue';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
// @ts-ignore
import { makeSelectGroupEntitiesIds } from 'services/groupEntities/selectors';

interface Props {
    groupId: number;
}

export default function EntityNamesValue(props: Props): React.ReactElement {
    const { groupId } = props;
    const entityIds = useSelector((state: AppState) =>
        makeSelectGroupEntitiesIds()(state, { groupId })
    );
    if (!entityIds || !entityIds.length) {
        return <span />;
    }

    return entityIds.map((entityId: number, index: number) => (
        <span key={entityId}>
            {!!index && ', '}
            <EntityNameValue entityId={entityId} />
        </span>
    ));
}
